/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ICON_DATA_OBJECT, ICON_TAG, SdsIcon } from '@squiz/sds';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AI_STRINGS } from '../../Constants/Strings.constants';
import { isGenerative } from '../../Utilities/formPredicates';
import { AiInstructionCarProps } from './AiInstructionCard.props';

export const AiInstructionCard = (props: AiInstructionCarProps): JSX.Element => {
  const ai = props.ai;
  const { t } = useTranslation();
  const labels = {
    instructionFieldDescriptionAlt: t(
      isGenerative(props.ai.type)
        ? AI_STRINGS.instructionFieldDescriptionAlt
        : AI_STRINGS.instructionFieldDescriptionChatbotAlt,
    ),
    instructions: t(AI_STRINGS.instructions),
    tags: t(AI_STRINGS.tags),
    tagsFieldDescription: t(AI_STRINGS.tagsFieldDescription),
  };

  return (
    <div className="instructions">
      {/* Instructions */}
      <span className="instructions-heading">
        <SdsIcon svg={ICON_DATA_OBJECT}></SdsIcon>
        <span className="instructions-heading-text">{labels.instructions}</span>
      </span>
      <span className="instructions-description">{labels.instructionFieldDescriptionAlt}</span>
      <div className="instructions-container">
        <span className="instructions-text" data-id="AI Instructions Text">
          {ai.instruction}
        </span>
      </div>
      {/* Tags */}
      {isGenerative(props.ai.type) && (
        <>
          <span className="instructions-heading">
            <SdsIcon svg={ICON_TAG}></SdsIcon>
            <span className="instructions-heading-text">{labels.tags}</span>
          </span>
          <span className="instructions-description">{labels.tagsFieldDescription}</span>
          <div className="instructions-container">
            <span className="instructions-text">{ai.tags.join(', ')}</span>
          </div>
        </>
      )}
    </div>
  );
};
